/* =========================================================
   NITIDUS — Swipe engine
   A dependency-free canvas motion graphic: the Nitidus mitt
   gathering loose pet hair off a fabric surface.
   <nit-demo data-surface="sofa" data-mode="auto|dirty|interactive|split">
   ========================================================= */
(function () {
  'use strict';
  if (customElements.get('nit-demo')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var HAIR = {
    gold:  ['#D6AE72', '#C8985A', '#E7CE9F', '#B88549', '#EFDDB9', '#DDBB84'],
    cream: ['#F4F1EA', '#E7E1D6', '#FFFFFF', '#D9D3C7', '#EEE8DC'],
    dark:  ['#5A4A3C', '#3E342C', '#76675A', '#2E2824', '#8D857C'],
    mixed: ['#D6AE72', '#F4F1EA', '#8D857C', '#C8985A', '#E7E1D6']
  };

  var SURFACES = {
    sofa:     { base: '#868E96', texture: 'weave',  hair: 'gold',  density: 105 },
    car:      { base: '#2B2F34', texture: 'carpet', hair: 'cream', density: 110 },
    clothing: { base: '#1D2B3C', texture: 'knit',   hair: 'cream', density: 130 },
    bedding:  { base: '#E9E2D5', texture: 'linen',  hair: 'dark',  density: 125 },
    petbed:   { base: '#6E7E8B', texture: 'fleece', hair: 'gold',  density: 100 },
    rug:      { base: '#B7A68E', texture: 'carpet', hair: 'dark',  density: 115 }
  };

  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(arr) { return arr[(Math.random() * arr.length) | 0]; }
  function gauss() { var u = 0, v = 0; while (!u) u = Math.random(); while (!v) v = Math.random(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function shade(hex, amt) {
    var n = parseInt(hex.slice(1), 16), r = (n >> 16) + amt, g = ((n >> 8) & 255) + amt, b = (n & 255) + amt;
    return 'rgb(' + clamp(r, 0, 255) + ',' + clamp(g, 0, 255) + ',' + clamp(b, 0, 255) + ')';
  }
  function mk(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }

  /* ---------- Fabric textures ---------- */
  function textureTile(kind, base) {
    var s = 96, c = mk(s, s), x = c.getContext('2d'), i, j;
    x.fillStyle = base; x.fillRect(0, 0, s, s);
    if (kind === 'weave') {
      for (i = 0; i < s; i += 3) {
        x.fillStyle = shade(base, (Math.random() * 14 - 7) | 0); x.globalAlpha = .55; x.fillRect(0, i, s, 1.4);
        x.fillStyle = shade(base, (Math.random() * 18 - 12) | 0); x.globalAlpha = .45; x.fillRect(i, 0, 1.2, s);
      }
    } else if (kind === 'knit') {
      x.lineWidth = 1.1;
      for (j = 0; j < s; j += 5) for (i = 0; i < s; i += 6) {
        x.strokeStyle = shade(base, ((Math.random() * 16) | 0) - 2); x.globalAlpha = .6;
        x.beginPath(); x.moveTo(i, j); x.lineTo(i + 3, j + 4); x.lineTo(i + 6, j); x.stroke();
      }
    } else if (kind === 'carpet') {
      for (i = 0; i < 2600; i++) {
        x.fillStyle = shade(base, ((Math.random() * 34) | 0) - 17); x.globalAlpha = rand(.35, .8);
        x.beginPath(); x.arc(Math.random() * s, Math.random() * s, rand(.5, 1.3), 0, 6.283); x.fill();
      }
    } else if (kind === 'fleece') {
      x.lineCap = 'round';
      for (i = 0; i < 1800; i++) {
        var fx = Math.random() * s, fy = Math.random() * s, fa = Math.random() * 6.283;
        x.strokeStyle = shade(base, ((Math.random() * 26) | 0) - 13); x.globalAlpha = rand(.3, .7); x.lineWidth = rand(.6, 1.2);
        for (var o = -1; o <= 1; o++) for (var q = -1; q <= 1; q++) { x.beginPath(); x.moveTo(fx + o * s, fy + q * s); x.lineTo(fx + o * s + Math.cos(fa) * 3, fy + q * s + Math.sin(fa) * 3); x.stroke(); }
      }
    } else if (kind === 'linen') {
      for (i = 0; i < s; i += 2) {
        x.fillStyle = shade(base, ((Math.random() * 10) | 0) - 6); x.globalAlpha = .5;
        var st = Math.random() * s; x.fillRect(st - s, i, rand(20, 90), 1); x.fillRect(st, i, rand(20, 90), 1);
      }
      for (i = 0; i < s; i += 4) { x.fillStyle = shade(base, -8); x.globalAlpha = .18; x.fillRect(i, 0, 1, s); }
    }
    x.globalAlpha = 1;
    return c;
  }

  function meshPattern(ctx) {
    var s = 4, c = mk(s * 2, s * 2), x = c.getContext('2d');
    x.fillStyle = '#1C1E21'; x.fillRect(0, 0, s * 2, s * 2);
    x.fillStyle = '#0A0B0C';
    [[2, 2], [6, 6]].forEach(function (p) { x.beginPath(); x.ellipse(p[0], p[1], 1.3, 1.1, 0, 0, 6.283); x.fill(); });
    return ctx.createPattern(c, 'repeat');
  }

  /* ---------- Mitt geometry (top view, back side) ---------- */
  function mittPath(ctx, w, h) {
    var l = -w / 2, t = -h / 2, rt = w * .5, rb = w * .32;
    ctx.beginPath();
    ctx.moveTo(l + rt, t);
    ctx.lineTo(l + w - rt + .001, t);
    ctx.quadraticCurveTo(l + w, t, l + w, t + rt);
    ctx.lineTo(l + w * 1.0, t + h - rb);
    ctx.quadraticCurveTo(l + w, t + h, l + w - rb, t + h);
    ctx.lineTo(l + rb, t + h);
    ctx.quadraticCurveTo(l, t + h, l, t + h - rb);
    ctx.lineTo(l, t + rt);
    ctx.quadraticCurveTo(l, t, l + rt, t);
    ctx.closePath();
  }


  /* =========================================================
     Scenes: recognisable objects (sofa, jumper, car seat, bed,
     pet bed, rug). Each draws its backdrop + fabric parts into a
     square stage and returns the fabric mask the hair sits on.
     ========================================================= */
  function RR(x, y, w, h, r) {
    var p = new Path2D(), rr = Math.min(r, w / 2, h / 2);
    p.moveTo(x + rr, y); p.lineTo(x + w - rr, y); p.quadraticCurveTo(x + w, y, x + w, y + rr);
    p.lineTo(x + w, y + h - rr); p.quadraticCurveTo(x + w, y + h, x + w - rr, y + h);
    p.lineTo(x + rr, y + h); p.quadraticCurveTo(x, y + h, x, y + h - rr);
    p.lineTo(x, y + rr); p.quadraticCurveTo(x, y, x + rr, y); p.closePath(); return p;
  }
  function Poly(pts, smooth) {
    var p = new Path2D(), n = pts.length, i;
    if (!smooth) { p.moveTo(pts[0][0], pts[0][1]); for (i = 1; i < n; i++) p.lineTo(pts[i][0], pts[i][1]); p.closePath(); return p; }
    var mid = function (a, b) { return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]; };
    var m0 = mid(pts[n - 1], pts[0]); p.moveTo(m0[0], m0[1]);
    for (i = 0; i < n; i++) { var m = mid(pts[i], pts[(i + 1) % n]); p.quadraticCurveTo(pts[i][0], pts[i][1], m[0], m[1]); }
    p.closePath(); return p;
  }
  function RP(pts, r) {
    var p = new Path2D(), n = pts.length, i;
    var m0 = [(pts[n - 1][0] + pts[0][0]) / 2, (pts[n - 1][1] + pts[0][1]) / 2]; p.moveTo(m0[0], m0[1]);
    for (i = 0; i < n; i++) { var a = pts[i], b = pts[(i + 1) % n]; p.arcTo(a[0], a[1], b[0], b[1], Array.isArray(r) ? r[i] : r); }
    p.closePath(); return p;
  }
  var texCache = {};
  function texPat(x, kind, base) { var k = kind + base; if (!texCache[k]) texCache[k] = textureTile(kind, base); return x.createPattern(texCache[k], 'repeat'); }

  // Paint one fabric part: texture, soft form shading, edge line, and add it to the hair mask.
  function part(x, S, mask, path, base, kind, o) {
    o = o || {};
    x.save();
    if (o.shadow !== false) { var sa = (o.shadowA || .28) / 4; x.save(); x.fillStyle = 'rgba(20,24,30,' + sa + ')'; for (var k = 1; k <= 4; k++) { x.translate(0, S * .005); x.fill(path); } x.restore(); }
    x.fillStyle = texPat(x, kind, base); x.fill(path);
    x.save(); x.clip(path);
    var b = o.box || [0, 0, S, S];
    var g = x.createLinearGradient(0, b[1], 0, b[1] + b[3]);
    g.addColorStop(0, 'rgba(255,250,240,' + (o.hi == null ? .16 : o.hi) + ')'); g.addColorStop(.55, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(10,16,24,' + (o.lo == null ? .26 : o.lo) + ')');
    x.fillStyle = g; x.fillRect(b[0] - 2, b[1] - 2, b[2] + 4, b[3] + 4);
    if (o.side !== false) {
      var gs = x.createLinearGradient(b[0], 0, b[0] + b[2], 0);
      gs.addColorStop(0, 'rgba(10,16,24,.14)'); gs.addColorStop(.18, 'rgba(0,0,0,0)'); gs.addColorStop(.82, 'rgba(0,0,0,0)'); gs.addColorStop(1, 'rgba(10,16,24,.16)');
      x.fillStyle = gs; x.fillRect(b[0] - 2, b[1] - 2, b[2] + 4, b[3] + 4);
    }
    x.lineWidth = S * .012; x.strokeStyle = 'rgba(255,255,255,.10)'; x.stroke(path);
    x.restore();
    x.lineWidth = Math.max(1, S * .004); x.strokeStyle = 'rgba(10,14,20,.35)'; x.stroke(path);
    x.restore();
    if (mask && o.hair !== false) mask.addPath(path);
  }
  function seam(x, S, pts, a) { x.save(); x.strokeStyle = 'rgba(10,14,20,' + (a || .28) + ')'; x.lineWidth = Math.max(1, S * .004); x.setLineDash([S * .012, S * .008]); x.beginPath(); x.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) x.lineTo(pts[i][0], pts[i][1]); x.stroke(); x.restore(); }
  function wall(x, W, H, top, bot, floorY, floorCol) {
    var g = x.createLinearGradient(0, 0, 0, H); g.addColorStop(0, top); g.addColorStop(1, bot); x.fillStyle = g; x.fillRect(0, 0, W, H);
    if (floorY != null) {
      x.fillStyle = floorCol; x.fillRect(0, floorY, W, H - floorY);
      x.strokeStyle = 'rgba(60,40,20,.12)'; x.lineWidth = 1;
      for (var i = 0; i < 6; i++) { x.beginPath(); x.moveTo(0, floorY + (H - floorY) * (i / 6) + 2); x.lineTo(W, floorY + (H - floorY) * (i / 6) + 2); x.stroke(); }
      var sg = x.createLinearGradient(0, floorY - 6, 0, floorY + 20); sg.addColorStop(0, 'rgba(0,0,0,.10)'); sg.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = sg; x.fillRect(0, floorY, W, 20);
    }
    var l = x.createRadialGradient(W * .18, H * .05, 0, W * .18, H * .05, Math.max(W, H)); l.addColorStop(0, 'rgba(255,246,225,.35)'); l.addColorStop(.6, 'rgba(255,255,255,0)'); x.fillStyle = l; x.fillRect(0, 0, W, H);
  }
  function wood(x, W, H, base) {
    x.fillStyle = base; x.fillRect(0, 0, W, H);
    for (var i = 0; i < 90; i++) { x.strokeStyle = 'rgba(90,60,30,' + rand(.04, .12) + ')'; x.lineWidth = rand(.6, 1.6); var y = Math.random() * H; x.beginPath(); x.moveTo(0, y); x.bezierCurveTo(W * .3, y + rand(-6, 6), W * .7, y + rand(-6, 6), W, y + rand(-4, 4)); x.stroke(); }
    var pw = Math.max(W, H) / 5; x.strokeStyle = 'rgba(70,45,20,.18)'; x.lineWidth = 1.2;
    for (var j = 1; j < 6; j++) { x.beginPath(); x.moveTo(0, j * pw); x.lineTo(W, j * pw); x.stroke(); }
  }

  /* ---------- v2 scene helpers: lighting, materials, props ---------- */
  // Soft contact shadow as a scaled radial gradient (no blur filter needed).
  function contact(x, cx, cy, rx, ry, a) {
    x.save(); x.translate(cx, cy); x.scale(1, ry / rx);
    var g = x.createRadialGradient(0, 0, 0, 0, 0, rx); g.addColorStop(0, 'rgba(30,22,14,' + a + ')'); g.addColorStop(1, 'rgba(30,22,14,0)');
    x.fillStyle = g; x.beginPath(); x.arc(0, 0, rx, 0, 6.2832); x.fill(); x.restore();
  }
  // Upholstered part: texture, form shading, ambient occlusion at the edges, rim light on top.
  function soft(x, S, mask, path, base, kind, box, o) {
    o = o || {};
    x.save();
    x.fillStyle = texPat(x, kind, base); x.fill(path);
    x.clip(path);
    var g = x.createLinearGradient(0, box[1], 0, box[1] + box[3]);
    g.addColorStop(0, 'rgba(255,250,238,' + (o.hi == null ? .22 : o.hi) + ')'); g.addColorStop(.45, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(8,12,20,' + (o.lo == null ? .3 : o.lo) + ')');
    x.fillStyle = g; x.fillRect(box[0] - 4, box[1] - 4, box[2] + 8, box[3] + 8);
    if (o.side !== false) {
      var gs = x.createLinearGradient(box[0], 0, box[0] + box[2], 0);
      gs.addColorStop(0, 'rgba(255,248,230,' + (o.left || .1) + ')'); gs.addColorStop(.25, 'rgba(0,0,0,0)'); gs.addColorStop(.8, 'rgba(0,0,0,0)'); gs.addColorStop(1, 'rgba(8,12,20,' + (o.right || .22) + ')');
      x.fillStyle = gs; x.fillRect(box[0] - 4, box[1] - 4, box[2] + 8, box[3] + 8);
    }
    // ambient occlusion: layered inner strokes
    for (var k = 3; k >= 1; k--) { x.lineWidth = S * .012 * k; x.strokeStyle = 'rgba(8,12,20,' + (.05 * (o.ao || 1)) + ')'; x.stroke(path); }
    // rim light along the top edge
    x.save(); x.translate(0, S * .004); x.lineWidth = S * .006; x.strokeStyle = 'rgba(255,250,240,' + (o.rim == null ? .28 : o.rim) + ')'; x.stroke(path); x.restore();
    x.restore();
    x.lineWidth = Math.max(1, S * .0035); x.strokeStyle = 'rgba(8,12,20,.42)'; x.stroke(path);
    if (mask && o.hair !== false) mask.addPath(path);
    if (o.cut) { var t = x.getTransform(); o.cut.addPath(path, new DOMMatrix([t.a / CUR_DPR, t.b / CUR_DPR, t.c / CUR_DPR, t.d / CUR_DPR, t.e / CUR_DPR, t.f / CUR_DPR])); }
  }
  var CUR_DPR = 1;
  // A fabric fold: dark valley with a light ridge beside it.
  function fold(x, S, pts, a) {
    a = a || 1;
    var line = function (dx, dy, col, w) { x.strokeStyle = col; x.lineWidth = w; x.beginPath(); x.moveTo(pts[0][0] + dx, pts[0][1] + dy); if (pts.length === 3) x.quadraticCurveTo(pts[1][0] + dx, pts[1][1] + dy, pts[2][0] + dx, pts[2][1] + dy); else x.bezierCurveTo(pts[1][0] + dx, pts[1][1] + dy, pts[2][0] + dx, pts[2][1] + dy, pts[3][0] + dx, pts[3][1] + dy); x.stroke(); };
    x.save(); x.lineCap = 'round';
    line(0, 0, 'rgba(8,12,20,' + .22 * a + ')', S * .006);
    line(S * .004, S * .003, 'rgba(255,250,240,' + .16 * a + ')', S * .004);
    x.restore();
  }
  function piping(x, S, path) { x.save(); x.lineWidth = S * .007; x.strokeStyle = 'rgba(8,12,20,.3)'; x.stroke(path); x.translate(0, -S * .002); x.lineWidth = S * .003; x.strokeStyle = 'rgba(255,255,255,.18)'; x.stroke(path); x.restore(); }
  function plaster(x, W, H, n) { for (var i = 0; i < n; i++) { x.fillStyle = Math.random() > .5 ? 'rgba(255,255,255,.05)' : 'rgba(80,60,40,.035)'; x.fillRect(Math.random() * W, Math.random() * H, rand(1, 3), rand(1, 3)); } }
  // Window light falling across a surface: soft panes with frame bars between them.
  function windowLight(x, pts, a) {
    x.save(); x.fillStyle = 'rgba(255,246,222,' + a + ')';
    pts.forEach(function (q) { x.beginPath(); x.moveTo(q[0][0], q[0][1]); for (var i = 1; i < q.length; i++) x.lineTo(q[i][0], q[i][1]); x.closePath(); x.fill(); });
    x.restore();
  }
  function perspectiveFloor(x, W, H, y0, base, S, ox) {
    var g = x.createLinearGradient(0, y0, 0, H); g.addColorStop(0, shade(base, -10)); g.addColorStop(1, shade(base, 12));
    x.fillStyle = g; x.fillRect(0, y0, W, H - y0);
    var vx = ox + S * .5, vy = y0 - S * 1.4;
    x.strokeStyle = 'rgba(80,52,24,.16)'; x.lineWidth = 1;
    for (var i = -14; i <= 14; i++) { var bx = vx + i * S * .14; x.beginPath(); x.moveTo(vx + (bx - vx) * ((y0 - vy) / (H - vy)), y0); x.lineTo(bx, H); x.stroke(); }
    for (var j = 0; j < 40; j++) { x.strokeStyle = 'rgba(90,60,30,' + rand(.03, .08) + ')'; var yy = rand(y0, H); x.beginPath(); x.moveTo(rand(0, W), yy); x.lineTo(rand(0, W), yy + rand(-2, 2)); x.stroke(); }
    x.fillStyle = 'rgba(0,0,0,.08)'; x.fillRect(0, y0, W, 2);
  }
  function oakTop(x, W, H, base) {
    x.fillStyle = base; x.fillRect(0, 0, W, H);
    var pw = Math.max(W, H) / 4.2;
    for (var p = 0; p * pw < W + pw; p++) {
      x.fillStyle = p % 2 ? 'rgba(255,255,255,.04)' : 'rgba(90,60,30,.04)'; x.fillRect(p * pw, 0, pw, H);
      for (var i = 0; i < 26; i++) {
        var gx = p * pw + rand(4, pw - 4); x.strokeStyle = 'rgba(110,72,36,' + rand(.05, .14) + ')'; x.lineWidth = rand(.6, 1.6);
        x.beginPath(); x.moveTo(gx, 0); x.bezierCurveTo(gx + rand(-8, 8), H * .3, gx + rand(-8, 8), H * .7, gx + rand(-5, 5), H); x.stroke();
      }
      x.strokeStyle = 'rgba(70,45,20,.28)'; x.lineWidth = 1.4; x.beginPath(); x.moveTo(p * pw, 0); x.lineTo(p * pw, H); x.stroke();
      var joint = rand(.2, .8) * H; x.beginPath(); x.moveTo(p * pw, joint); x.lineTo(p * pw + pw, joint); x.stroke();
    }
  }

  var SCENES = {
    /* ---------------- The couch: a living-room corner ---------------- */
    sofa: { hair: 'gold', density: 150, draw: function (x, W, H, S, ox, oy) {
      var u = function (v) { return v * S; }, X = function (v) { return ox + u(v); }, Y = function (v) { return oy + u(v); }, m = new Path2D(), cut = new Path2D();
      var floorY = Y(.8);
      var wg = x.createLinearGradient(0, 0, 0, floorY); wg.addColorStop(0, '#EEE7DC'); wg.addColorStop(1, '#E2D9CB'); x.fillStyle = wg; x.fillRect(0, 0, W, floorY);
      plaster(x, W, floorY, 900);
      windowLight(x, [[[X(-.2), 0], [X(.18), 0], [X(.62), floorY], [X(.24), floorY]], [[X(.24), 0], [X(.4), 0], [X(.84), floorY], [X(.68), floorY]]], .16);
      // framed print with the brand swipe
      contact(x, X(.5), Y(.12) + u(.13), u(.2), u(.02), .18);
      x.fillStyle = '#1B1B1B'; x.fillRect(X(.33), Y(-.02), u(.34), u(.25));
      x.fillStyle = '#F7F4EE'; x.fillRect(X(.345), Y(-.005), u(.31), u(.22));
      x.fillStyle = '#0B1F33'; x.fillRect(X(.38), Y(.025), u(.24), u(.16));
      x.strokeStyle = '#F7C928'; x.lineWidth = u(.014); x.lineCap = 'round'; x.beginPath(); x.moveTo(X(.4), Y(.15)); x.quadraticCurveTo(X(.5), Y(.08), X(.6), Y(.1)); x.stroke();
      // plant peeking in from the right
      x.save(); for (var i = 0; i < 9; i++) { x.fillStyle = ['#3E6B4A', '#4F7D59', '#35603F'][i % 3]; x.save(); x.translate(X(1.02), Y(.62)); x.rotate(-2.2 + i * .22); x.beginPath(); x.ellipse(u(.16), 0, u(.16), u(.035), 0, 0, 6.28); x.fill(); x.restore(); } x.restore();
      // skirting + floor + rug
      x.fillStyle = '#F4EFE7'; x.fillRect(0, floorY - u(.028), W, u(.028)); x.fillStyle = 'rgba(0,0,0,.08)'; x.fillRect(0, floorY - u(.028), W, 1.5);
      perspectiveFloor(x, W, H, floorY, '#C4A27A', S, ox);
      x.save(); x.beginPath(); x.ellipse(X(.5), Y(.9), u(.6), u(.1), 0, 0, 6.28); x.fillStyle = texPat(x, 'carpet', '#E6DCCB'); x.fill(); x.strokeStyle = 'rgba(0,0,0,.08)'; x.lineWidth = 2; x.stroke(); x.restore();
      contact(x, X(.5), Y(.8), u(.52), u(.05), .35);
      var G = '#8E969E', GD = '#7A828A';
      // legs
      [[.14, .755], [.83, .755]].forEach(function (l) { var lg = x.createLinearGradient(X(l[0]), 0, X(l[0] + .03), 0); lg.addColorStop(0, '#8A6038'); lg.addColorStop(1, '#5E3F22'); x.fillStyle = lg; x.beginPath(); x.moveTo(X(l[0]), Y(l[1])); x.lineTo(X(l[0] + .03), Y(l[1])); x.lineTo(X(l[0] + .024), Y(l[1] + .05)); x.lineTo(X(l[0] + .008), Y(l[1] + .05)); x.fill(); });
      // back frame + base
      soft(x, S, null, RR(X(.06), Y(.36), u(.88), u(.34), u(.05)), GD, 'weave', [X(.06), Y(.36), u(.88), u(.34)], { hair: false, rim: .15 });
      soft(x, S, m, RR(X(.12), Y(.66), u(.76), u(.1), u(.02)), GD, 'weave', [X(.12), Y(.66), u(.76), u(.1)], { hi: .05, lo: .35 });
      // back cushions (slightly slouched tops)
      [[.125, .3], [.505, .3]].forEach(function (c, i) {
        var p = new Path2D(), x0 = X(c[0]), y0 = Y(c[1]), w = u(.37), h = u(.28);
        p.moveTo(x0 + w * .08, y0 + h * .06); p.quadraticCurveTo(x0 + w * .5, y0 - h * .07, x0 + w * .92, y0 + h * .05);
        p.quadraticCurveTo(x0 + w * 1.02, y0 + h * .12, x0 + w, y0 + h * .35); p.lineTo(x0 + w * .99, y0 + h); p.lineTo(x0 + w * .01, y0 + h); p.lineTo(x0, y0 + h * .35);
        p.quadraticCurveTo(x0 - w * .02, y0 + h * .1, x0 + w * .08, y0 + h * .06); p.closePath();
        soft(x, S, m, p, G, 'weave', [x0, y0, w, h], { lo: .26 });
        fold(x, S, [[x0 + w * .1, y0 + h * .55], [x0 + w * .3, y0 + h * .5], [x0 + w * .45, y0 + h * .62]], .7);
        fold(x, S, [[x0 + w * .6, y0 + h * .3], [x0 + w * .75, y0 + h * .38], [x0 + w * .9, y0 + h * .34]], .6);
      });
      // throw pillows: cream boucle left, navy knit right
      x.save(); x.translate(X(.24), Y(.43)); x.rotate(-.12); soft(x, S, null, RR(-u(.09), -u(.085), u(.18), u(.17), u(.05)), '#EFE9DE', 'fleece', [-u(.09), -u(.085), u(.18), u(.17)], { hair: false, lo: .22, cut: cut }); x.restore();
      x.save(); x.translate(X(.76), Y(.44)); x.rotate(.14); soft(x, S, null, RR(-u(.085), -u(.08), u(.17), u(.16), u(.045)), '#22344B', 'knit', [-u(.085), -u(.08), u(.17), u(.16)], { hair: false, lo: .3, cut: cut }); x.restore();
      // seat cushions: top face + front face with piping between
      [[.13, .375], [.5, .375]].forEach(function (c) {
        var top = RR(X(c[0]), Y(.545), u(c[1]), u(.07), u(.03)), front = RR(X(c[0]), Y(.595), u(c[1]), u(.09), u(.02));
        soft(x, S, m, front, GD, 'weave', [X(c[0]), Y(.595), u(c[1]), u(.09)], { hi: .06, lo: .32, rim: .1 });
        soft(x, S, m, top, '#9CA4AC', 'weave', [X(c[0]), Y(.545), u(c[1]), u(.07)], { hi: .3, lo: .08, ao: .6 });
        piping(x, S, RR(X(c[0]), Y(.595), u(c[1]), u(.004), 1));
        fold(x, S, [[X(c[0] + .05), Y(.64)], [X(c[0] + .12), Y(.63)], [X(c[0] + .16), Y(.66)]], .6);
      });
      // arms: top roll + front panel
      [[.03, 1], [.84, -1]].forEach(function (a) {
        var body = RR(X(a[0]), Y(.46), u(.13), u(.31), u(.045));
        soft(x, S, m, body, G, 'weave', [X(a[0]), Y(.46), u(.13), u(.31)], { lo: .3, left: a[1] > 0 ? .16 : .04 });
        soft(x, S, m, RR(X(a[0]) - u(.005), Y(.445), u(.14), u(.07), u(.035)), '#9AA2AA', 'weave', [X(a[0]), Y(.445), u(.14), u(.07)], { hi: .32, lo: .1 });
        piping(x, S, RR(X(a[0] + .01), Y(.52), u(.11), u(.004), 1));
      });
      // knit throw draped over the right arm: rounds over the top roll, hangs down the front
      var th = new Path2D(); th.moveTo(X(.835), Y(.47)); th.quadraticCurveTo(X(.9), Y(.425), X(.975), Y(.465));
      th.lineTo(X(.972), Y(.6)); th.quadraticCurveTo(X(.955), Y(.62), X(.935), Y(.605)); th.quadraticCurveTo(X(.91), Y(.625), X(.885), Y(.605)); th.quadraticCurveTo(X(.86), Y(.622), X(.84), Y(.6)); th.closePath();
      soft(x, S, null, th, '#E4D9C6', 'knit', [X(.835), Y(.43), u(.14), u(.19)], { hair: false, lo: .22, cut: cut });
      fold(x, S, [[X(.87), Y(.47)], [X(.875), Y(.53)], [X(.868), Y(.6)]], .9); fold(x, S, [[X(.93), Y(.465)], [X(.935), Y(.54)], [X(.93), Y(.6)]], .9);
      x.strokeStyle = 'rgba(190,176,152,.95)'; x.lineWidth = 1.2; for (var f = 0; f < 12; f++) { var fx = X(.845 + f * .011); x.beginPath(); x.moveTo(fx, Y(.605 + (f % 2) * .006)); x.lineTo(fx + rand(-1, 1), Y(.635)); x.stroke(); }
      return { mask: m, cut: cut, clean: [X(.14), Y(.32), u(.72), u(.36)], mitt: .15 };
    } },

    /* ---------------- Your clothes: a flat-lay, right before heading out ---------------- */
    clothing: { hair: 'cream', density: 190, draw: function (x, W, H, S, ox, oy) {
      var u = function (v) { return v * S; }, X = function (v) { return ox + u(v); }, Y = function (v) { return oy + u(v); }, m = new Path2D();
      oakTop(x, W, H, '#D9C4A4');
      var N = '#1F3047';
      // silhouette: crew-neck jumper, sleeves relaxed at slightly different angles
      var body = new Path2D();
      body.moveTo(X(.4), Y(.13)); body.quadraticCurveTo(X(.5), Y(.17), X(.6), Y(.13));
      body.lineTo(X(.77), Y(.18)); body.quadraticCurveTo(X(.83), Y(.2), X(.86), Y(.27));
      body.lineTo(X(.97), Y(.6)); body.lineTo(X(.87), Y(.64)); body.lineTo(X(.74), Y(.37));
      body.lineTo(X(.735), Y(.8)); body.lineTo(X(.265), Y(.8)); body.lineTo(X(.26), Y(.37));
      body.lineTo(X(.14), Y(.66)); body.lineTo(X(.04), Y(.62)); body.lineTo(X(.15), Y(.27));
      body.quadraticCurveTo(X(.18), Y(.2), X(.23), Y(.18)); body.closePath();
      // soft drop shadow on the timber
      x.save(); for (var k = 1; k <= 5; k++) { x.translate(u(.003), u(.004)); x.fillStyle = 'rgba(40,24,10,.045)'; x.fill(body); } x.restore();
      soft(x, S, m, body, N, 'knit', [X(.04), Y(.13), u(.93), u(.67)], { hi: .12, lo: .25, rim: .1, left: .06, right: .15 });
      x.save(); x.clip(body);
      // cable-knit panels: twisted rope columns
      [.4, .6].forEach(function (cx) {
        for (var yy = .24; yy < .78; yy += .045) {
          [-1, 1].forEach(function (sg) {
            x.beginPath(); x.moveTo(X(cx - .025 * sg), Y(yy)); x.bezierCurveTo(X(cx - .025 * sg), Y(yy + .02), X(cx + .025 * sg), Y(yy + .025), X(cx + .025 * sg), Y(yy + .045));
            x.lineWidth = u(.016); x.strokeStyle = 'rgba(0,0,0,.28)'; x.stroke(); x.lineWidth = u(.009); x.strokeStyle = 'rgba(120,150,190,.22)'; x.stroke();
          });
        }
        x.fillStyle = 'rgba(0,0,0,.18)'; x.fillRect(X(cx - .05), Y(.22), u(.006), u(.56)); x.fillRect(X(cx + .044), Y(.22), u(.006), u(.56));
      });
      // rib bands: hem + cuffs
      var ribs = function (x0, y0, x1, y1, n, ang) { for (var i = 0; i < n; i++) { var t = i / n; x.strokeStyle = i % 2 ? 'rgba(0,0,0,.25)' : 'rgba(140,170,210,.14)'; x.lineWidth = u(.006); x.beginPath(); var sx = x0 + (x1 - x0) * t, sy = y0 + (y1 - y0) * t; x.moveTo(sx, sy); x.lineTo(sx + Math.cos(ang) * u(.06), sy + Math.sin(ang) * u(.06)); x.stroke(); } };
      x.fillStyle = 'rgba(0,0,0,.12)'; x.fillRect(X(.26), Y(.74), u(.48), u(.06)); ribs(X(.27), Y(.74), X(.73), Y(.74), 60, Math.PI / 2);
      ribs(X(.05), Y(.585), X(.14), Y(.625), 12, 1.95); ribs(X(.87), Y(.6), X(.955), Y(.565), 12, 1.2);
      // folds: under the arms and across the body
      fold(x, S, [[X(.27), Y(.4)], [X(.33), Y(.48)], [X(.3), Y(.6)]], 1.2);
      fold(x, S, [[X(.73), Y(.4)], [X(.68), Y(.5)], [X(.7), Y(.62)]], 1.2);
      fold(x, S, [[X(.3), Y(.66)], [X(.45), Y(.63)], [X(.55), Y(.68)], [X(.7), Y(.65)]], .9);
      fold(x, S, [[X(.18), Y(.35)], [X(.16), Y(.45)], [X(.12), Y(.55)]], .8);
      x.restore();
      // ribbed crew neck
      var neckO = new Path2D(); neckO.ellipse(X(.5), Y(.15), u(.11), u(.05), 0, 0, 6.28);
      var neckI = new Path2D(); neckI.ellipse(X(.5), Y(.152), u(.078), u(.03), 0, 0, 6.28);
      x.fillStyle = '#18263A'; x.fill(neckO); x.save(); x.clip(neckO);
      for (var r = 0; r < 64; r++) { var a = r / 64 * 6.283; x.strokeStyle = r % 2 ? 'rgba(0,0,0,.3)' : 'rgba(140,170,210,.16)'; x.lineWidth = u(.005); x.beginPath(); x.moveTo(X(.5) + Math.cos(a) * u(.078), Y(.152) + Math.sin(a) * u(.03)); x.lineTo(X(.5) + Math.cos(a) * u(.11), Y(.15) + Math.sin(a) * u(.05)); x.stroke(); }
      x.restore(); x.fillStyle = '#0E1827'; x.fill(neckI);
      x.fillStyle = 'rgba(255,255,255,.7)'; x.fillRect(X(.475), Y(.13), u(.05), u(.018)); // care label
      // props: sunglasses, keys, coffee
      x.save(); x.translate(X(.83), Y(.08)); x.rotate(.35);
      contact(x, u(.01), u(.03), u(.12), u(.03), .25);
      [-1, 1].forEach(function (s2) { var lg = x.createLinearGradient(0, -u(.03), 0, u(.03)); lg.addColorStop(0, '#3B2A1E'); lg.addColorStop(1, '#1A120C'); x.fillStyle = lg; x.beginPath(); x.ellipse(s2 * u(.055), 0, u(.045), u(.034), 0, 0, 6.28); x.fill(); x.strokeStyle = '#8A5A2E'; x.lineWidth = u(.008); x.stroke(); x.fillStyle = 'rgba(255,255,255,.18)'; x.beginPath(); x.ellipse(s2 * u(.055) - u(.012), -u(.012), u(.014), u(.007), -.4, 0, 6.28); x.fill(); });
      x.strokeStyle = '#8A5A2E'; x.lineWidth = u(.008); x.beginPath(); x.moveTo(-u(.012), -u(.005)); x.quadraticCurveTo(0, -u(.018), u(.012), -u(.005)); x.stroke(); x.restore();
      x.save(); x.translate(X(.12), Y(.86)); x.rotate(-.5);
      contact(x, u(.02), u(.01), u(.08), u(.03), .25);
      x.strokeStyle = '#B9BEC4'; x.lineWidth = u(.007); x.beginPath(); x.arc(0, 0, u(.028), 0, 6.28); x.stroke();
      x.fillStyle = '#16181B'; x.beginPath(); if (x.roundRect) x.roundRect(u(.02), -u(.022), u(.08), u(.044), u(.018)); else x.rect(u(.02), -u(.022), u(.08), u(.044)); x.fill();
      x.fillStyle = '#2C3035'; x.beginPath(); x.arc(u(.075), 0, u(.011), 0, 6.28); x.fill(); x.fillStyle = '#C9CED3'; x.fillRect(u(.1), -u(.006), u(.05), u(.012)); x.restore();
      contact(x, X(.9), Y(.9), u(.085), u(.085), .3);
      x.fillStyle = '#FAFAF8'; x.beginPath(); x.arc(X(.89), Y(.885), u(.07), 0, 6.28); x.fill(); x.strokeStyle = 'rgba(0,0,0,.12)'; x.lineWidth = 1; x.stroke();
      var cg = x.createRadialGradient(X(.885), Y(.88), 0, X(.89), Y(.885), u(.055)); cg.addColorStop(0, '#E9D3B4'); cg.addColorStop(.5, '#C7935E'); cg.addColorStop(1, '#8A5A30'); x.fillStyle = cg; x.beginPath(); x.arc(X(.89), Y(.885), u(.055), 0, 6.28); x.fill();
      x.strokeStyle = 'rgba(255,245,230,.8)'; x.lineWidth = u(.006); x.beginPath(); x.moveTo(X(.87), Y(.87)); x.bezierCurveTo(X(.9), Y(.85), X(.91), Y(.9), X(.89), Y(.9)); x.stroke();
      x.fillStyle = '#FAFAF8'; x.beginPath(); x.ellipse(X(.965), Y(.885), u(.022), u(.012), 0, 0, 6.28); x.fill();
      // window light + frame shadow across everything
      windowLight(x, [[[X(-.3), Y(-.1)], [X(.2), Y(-.1)], [X(.55), Y(1.1)], [X(.05), Y(1.1)]], [[X(.26), Y(-.1)], [X(.7), Y(-.1)], [X(1.05), Y(1.1)], [X(.61), Y(1.1)]]], .1);
      return { mask: m, clean: [X(.22), Y(.2), u(.56), u(.56)], mitt: .19 };
    } },

    /* ---------------- The car: driver's seat, daylight through the door ---------------- */
    car: { hair: 'gold', density: 170, draw: function (x, W, H, S, ox, oy) {
      var u = function (v) { return v * S; }, X = function (v) { return ox + u(v); }, Y = function (v) { return oy + u(v); }, m = new Path2D();
      var bg = x.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, '#2A2F35'); bg.addColorStop(1, '#121417'); x.fillStyle = bg; x.fillRect(0, 0, W, H);
      // door with window: daylight outside
      var win = new Path2D(); win.moveTo(0, Y(-.02)); win.lineTo(X(.16), Y(.02)); win.lineTo(X(.12), Y(.36)); win.lineTo(0, Y(.4)); win.closePath();
      var sky = x.createLinearGradient(0, Y(0), 0, Y(.4)); sky.addColorStop(0, '#DCEAF2'); sky.addColorStop(.6, '#BCD3C0'); sky.addColorStop(1, '#7E9E7E'); x.fillStyle = sky; x.fill(win);
      x.save(); x.clip(win); for (var t = 0; t < 14; t++) { x.fillStyle = 'rgba(70,110,70,' + rand(.2, .5) + ')'; x.beginPath(); x.arc(rand(0, X(.16)), Y(rand(.22, .4)), u(rand(.02, .05)), 0, 6.28); x.fill(); } x.restore();
      x.strokeStyle = '#1B1E22'; x.lineWidth = u(.018); x.stroke(win);
      var door = new Path2D(); door.moveTo(0, Y(.4)); door.lineTo(X(.12), Y(.36)); door.lineTo(X(.1), H); door.lineTo(0, H); door.closePath();
      var dg = x.createLinearGradient(0, 0, X(.12), 0); dg.addColorStop(0, '#2F343A'); dg.addColorStop(1, '#3D434A'); x.fillStyle = dg; x.fill(door);
      x.fillStyle = '#23272C'; x.fillRect(0, Y(.52), X(.11), u(.05)); x.fillStyle = 'rgba(255,255,255,.08)'; x.fillRect(0, Y(.52), X(.11), 2);
      // light spill from the window onto the cabin
      var spill = x.createRadialGradient(X(.05), Y(.15), 0, X(.05), Y(.15), u(.9)); spill.addColorStop(0, 'rgba(230,240,245,.22)'); spill.addColorStop(1, 'rgba(230,240,245,0)'); x.fillStyle = spill; x.fillRect(0, 0, W, H);
      // centre console on the right + floor mat
      x.fillStyle = '#1C1F23'; x.beginPath(); x.moveTo(X(.9), Y(.5)); x.lineTo(W, Y(.46)); x.lineTo(W, H); x.lineTo(X(.92), H); x.closePath(); x.fill();
      x.fillStyle = '#2A2E33'; x.fillRect(X(.93), Y(.58), W - X(.93), u(.05));
      x.fillStyle = '#0C0D0F'; x.beginPath(); x.ellipse(X(.97), Y(.72), u(.035), u(.018), 0, 0, 6.28); x.fill();
      x.fillStyle = texPat(x, 'carpet', '#24272B'); x.fillRect(X(.08), Y(.88), u(.84), H - Y(.88));
      contact(x, X(.5), Y(.88), u(.42), u(.04), .6);
      // seatbelt hanging at the B-pillar
      x.fillStyle = '#3E444B'; x.fillRect(X(.13), Y(.04), u(.035), u(.6)); x.fillStyle = 'rgba(255,255,255,.07)'; x.fillRect(X(.13), Y(.04), u(.006), u(.6));
      x.fillStyle = '#9CA3AA'; x.fillRect(X(.125), Y(.6), u(.045), u(.05));
      var L = '#3A3F46', F = '#5A616A';
      // headrest
      x.fillStyle = '#AEB5BC'; x.fillRect(X(.445), Y(.16), u(.014), u(.08)); x.fillRect(X(.541), Y(.16), u(.014), u(.08));
      var hr = RP([[X(.36), Y(.035)], [X(.64), Y(.035)], [X(.655), Y(.17)], [X(.345), Y(.17)]], [u(.05), u(.05), u(.03), u(.03)]);
      soft(x, S, m, hr, L, 'carpet', [X(.345), Y(.035), u(.31), u(.135)], { left: .25 });
      x.save(); x.setLineDash([u(.008), u(.006)]); x.strokeStyle = 'rgba(0,0,0,.35)'; x.lineWidth = 1.2; x.stroke(RP([[X(.375), Y(.05)], [X(.625), Y(.05)], [X(.638), Y(.155)], [X(.362), Y(.155)]], [u(.04), u(.04), u(.02), u(.02)])); x.restore();
      // backrest shell with bolsters
      var shell = RP([[X(.22), Y(.22)], [X(.78), Y(.22)], [X(.82), Y(.64)], [X(.18), Y(.64)]], [u(.09), u(.09), u(.03), u(.03)]);
      soft(x, S, m, shell, L, 'carpet', [X(.18), Y(.22), u(.64), u(.42)], { left: .3, right: .3 });
      // quilted centre insert
      var ins = RP([[X(.34), Y(.25)], [X(.66), Y(.25)], [X(.68), Y(.6)], [X(.32), Y(.6)]], [u(.05), u(.05), u(.02), u(.02)]);
      soft(x, S, m, ins, F, 'weave', [X(.32), Y(.25), u(.36), u(.35)], { hi: .18, lo: .3 });
      x.save(); x.clip(ins); x.strokeStyle = 'rgba(0,0,0,.3)'; x.lineWidth = 1.2; x.setLineDash([u(.006), u(.005)]);
      for (var d = -8; d <= 8; d++) { x.beginPath(); x.moveTo(X(.5 + d * .05) - u(.4), Y(.2)); x.lineTo(X(.5 + d * .05) + u(.4), Y(.64)); x.stroke(); x.beginPath(); x.moveTo(X(.5 + d * .05) + u(.4), Y(.2)); x.lineTo(X(.5 + d * .05) - u(.4), Y(.64)); x.stroke(); }
      x.setLineDash([]); x.fillStyle = 'rgba(0,0,0,.25)'; x.fillRect(X(.32), Y(.47), u(.36), u(.012)); x.restore();
      // seat cushion: top + front face, bolsters
      var sb = RP([[X(.2), Y(.62)], [X(.8), Y(.62)], [X(.9), Y(.8)], [X(.1), Y(.8)]], [u(.03), u(.03), u(.05), u(.05)]);
      soft(x, S, m, sb, L, 'carpet', [X(.1), Y(.62), u(.8), u(.18)], { left: .3 });
      var st = RP([[X(.31), Y(.625)], [X(.69), Y(.625)], [X(.74), Y(.78)], [X(.26), Y(.78)]], [u(.02), u(.02), u(.03), u(.03)]);
      soft(x, S, m, st, '#636B74', 'weave', [X(.26), Y(.625), u(.48), u(.155)], { hi: .3, lo: .15 });
      x.save(); x.clip(st); x.strokeStyle = 'rgba(0,0,0,.25)'; x.lineWidth = 1.1; x.setLineDash([u(.006), u(.005)]); for (var q = 1; q < 4; q++) { x.beginPath(); x.moveTo(X(.3), Y(.625 + q * .04)); x.lineTo(X(.72), Y(.625 + q * .04)); x.stroke(); } x.restore();
      var sf = RP([[X(.1), Y(.8)], [X(.9), Y(.8)], [X(.88), Y(.88)], [X(.12), Y(.88)]], u(.02));
      soft(x, S, m, sf, '#2F3339', 'carpet', [X(.1), Y(.8), u(.8), u(.08)], { hi: .05, lo: .4, rim: .15 });
      // buckle
      x.fillStyle = '#16181B'; x.fillRect(X(.84), Y(.55), u(.05), u(.1)); x.fillStyle = '#C3C8CD'; x.fillRect(X(.852), Y(.56), u(.026), u(.02)); x.fillStyle = '#C0392B'; x.fillRect(X(.855), Y(.6), u(.02), u(.01));
      return { mask: m, clean: [X(.24), Y(.27), u(.52), u(.54)], mitt: .16 };
    } },

    /* ---------------- The bed: morning light, tufted headboard ---------------- */
    bedding: { hair: 'dark', density: 210, draw: function (x, W, H, S, ox, oy) {
      var u = function (v) { return v * S; }, X = function (v) { return ox + u(v); }, Y = function (v) { return oy + u(v); }, m = new Path2D();
      var floorY = Y(.86), cut = new Path2D();
      var wg = x.createLinearGradient(0, 0, 0, floorY); wg.addColorStop(0, '#E8E1D6'); wg.addColorStop(1, '#DCD2C3'); x.fillStyle = wg; x.fillRect(0, 0, W, floorY);
      plaster(x, W, floorY, 800);
      // lamp glow on the wall
      var glow = x.createRadialGradient(X(.95), Y(.3), 0, X(.95), Y(.3), u(.45)); glow.addColorStop(0, 'rgba(255,214,150,.55)'); glow.addColorStop(1, 'rgba(255,214,150,0)'); x.fillStyle = glow; x.fillRect(0, 0, W, floorY);
      windowLight(x, [[[X(-.3), Y(-.2)], [X(.05), Y(-.2)], [X(.45), floorY], [X(.1), floorY]]], .14);
      perspectiveFloor(x, W, H, floorY, '#B99771', S, ox);
      contact(x, X(.48), floorY, u(.55), u(.05), .4);
      // headboard with button tufting
      var hb = RP([[X(.02), Y(.1)], [X(.9), Y(.1)], [X(.9), Y(.56)], [X(.02), Y(.56)]], [u(.06), u(.06), 0, 0]);
      soft(x, S, null, hb, '#B7AC9C', 'weave', [X(.02), Y(.1), u(.88), u(.46)], { hair: false, lo: .2, ao: 1.3 });
      x.save(); x.clip(hb);
      var cols = 8, rows = 3, bw = .88 / cols, bh = .12;
      for (var rI = 0; rI < rows; rI++) for (var cI = 0; cI <= cols; cI++) {
        var bx = X(.02 + (cI + (rI % 2 ? .5 : 0)) * bw), by = Y(.16 + rI * bh);
        [[1, 1], [-1, 1], [1, -1], [-1, -1]].forEach(function (dd) { x.strokeStyle = 'rgba(60,48,36,.28)'; x.lineWidth = 1.4; x.beginPath(); x.moveTo(bx, by); x.lineTo(bx + dd[0] * u(bw / 2), by + dd[1] * u(bh / 2)); x.stroke(); x.strokeStyle = 'rgba(255,250,240,.22)'; x.beginPath(); x.moveTo(bx + 1.5, by + 1.5); x.lineTo(bx + dd[0] * u(bw / 2) + 1.5, by + dd[1] * u(bh / 2) + 1.5); x.stroke(); });
        var bgd = x.createRadialGradient(bx - 1, by - 1, 0, bx, by, u(.012)); bgd.addColorStop(0, '#CFC5B6'); bgd.addColorStop(1, '#6E6254'); x.fillStyle = bgd; x.beginPath(); x.arc(bx, by, u(.011), 0, 6.28); x.fill();
      }
      x.restore();
      // bedside table + lamp (right)
      contact(x, X(1.0), floorY, u(.14), u(.02), .4);
      var tg = x.createLinearGradient(X(.92), 0, W, 0); tg.addColorStop(0, '#9B7650'); tg.addColorStop(1, '#7A5A3A'); x.fillStyle = tg; x.fillRect(X(.92), Y(.52), W - X(.92), floorY - Y(.52));
      x.fillStyle = 'rgba(0,0,0,.2)'; x.fillRect(X(.92), Y(.6), W - X(.92), 2); x.fillStyle = '#C8A26F'; x.fillRect(X(.96), Y(.64), u(.04), u(.012));
      x.fillStyle = '#E9E3D8'; x.beginPath(); x.ellipse(X(.99), Y(.47), u(.05), u(.055), 0, 0, 6.28); x.fill();
      var sh = x.createLinearGradient(0, Y(.3), 0, Y(.42)); sh.addColorStop(0, '#FFE7B8'); sh.addColorStop(1, '#F1CE8C'); x.fillStyle = sh; x.beginPath(); x.moveTo(X(.93), Y(.42)); x.lineTo(X(.96), Y(.3)); x.lineTo(X(1.04), Y(.3)); x.lineTo(X(1.07), Y(.42)); x.closePath(); x.fill();
      // pillows
      var pil = function (px, py, pw, ph, col, kind) { var p = new Path2D(); p.moveTo(px + pw * .06, py + ph * .08); p.quadraticCurveTo(px + pw * .5, py - ph * .1, px + pw * .94, py + ph * .08); p.quadraticCurveTo(px + pw * 1.04, py + ph * .5, px + pw * .94, py + ph * .92); p.quadraticCurveTo(px + pw * .5, py + ph * 1.08, px + pw * .06, py + ph * .92); p.quadraticCurveTo(px - pw * .04, py + ph * .5, px + pw * .06, py + ph * .08); p.closePath(); return p; };
      soft(x, S, m, pil(X(.07), Y(.33), u(.4), u(.19), 0), '#F4F0E8', 'linen', [X(.07), Y(.33), u(.4), u(.19)], { lo: .18 });
      soft(x, S, m, pil(X(.46), Y(.33), u(.4), u(.19), 0), '#F4F0E8', 'linen', [X(.46), Y(.33), u(.4), u(.19)], { lo: .18 });
      fold(x, S, [[X(.15), Y(.44)], [X(.24), Y(.42)], [X(.3), Y(.45)]], .7); fold(x, S, [[X(.62), Y(.43)], [X(.7), Y(.41)], [X(.78), Y(.44)]], .7);
      soft(x, S, null, pil(X(.33), Y(.43), u(.24), u(.1), 0), '#22344B', 'knit', [X(.33), Y(.43), u(.24), u(.1)], { hair: false, lo: .3, cut: cut });
      // duvet: turned-down band, top surface, draped front
      var top = RP([[X(.02), Y(.52)], [X(.9), Y(.52)], [X(.93), Y(.74)], [X(-.01), Y(.74)]], u(.02));
      soft(x, S, m, top, '#EEE8DD', 'linen', [X(-.01), Y(.52), u(.94), u(.22)], { hi: .3, lo: .08 });
      var band = RP([[X(.02), Y(.5)], [X(.9), Y(.5)], [X(.905), Y(.56)], [X(.015), Y(.56)]], u(.02));
      soft(x, S, m, band, '#FAF8F3', 'linen', [X(.015), Y(.5), u(.89), u(.06)], { hi: .2, lo: .12 });
      var front = new Path2D(); front.moveTo(X(-.01), Y(.74)); front.lineTo(X(.93), Y(.74)); front.lineTo(X(.94), Y(.85));
      for (var w2 = 0; w2 <= 8; w2++) front.quadraticCurveTo(X(.94 - w2 * .119 + .06), Y(.87 + (w2 % 2) * .012), X(.94 - (w2 + 1) * .119 + .01), Y(.85));
      front.closePath();
      soft(x, S, m, front, '#E2DBCE', 'linen', [X(-.01), Y(.74), u(.95), u(.12)], { hi: .05, lo: .28, rim: .3 });
      [.12, .3, .5, .68, .84].forEach(function (fx) { fold(x, S, [[X(fx), Y(.745)], [X(fx + .01), Y(.8)], [X(fx - .01), Y(.855)]], .8); });
      fold(x, S, [[X(.1), Y(.6)], [X(.25), Y(.63)], [X(.4), Y(.6)]], .6); fold(x, S, [[X(.55), Y(.66)], [X(.7), Y(.62)], [X(.85), Y(.66)]], .6);
      // mustard knit bed runner across the foot: lies on top, then hangs over the front edge
      var rt = new Path2D(); rt.moveTo(X(-.01), Y(.655)); rt.quadraticCurveTo(X(.45), Y(.64), X(.925), Y(.645)); rt.lineTo(X(.93), Y(.74)); rt.lineTo(X(-.01), Y(.74)); rt.closePath();
      soft(x, S, null, rt, '#CF9C35', 'knit', [X(-.01), Y(.645), u(.94), u(.095)], { hair: false, hi: .25, lo: .12, cut: cut });
      var rf = new Path2D(); rf.moveTo(X(-.01), Y(.74)); rf.lineTo(X(.93), Y(.74)); rf.lineTo(X(.935), Y(.805)); rf.lineTo(X(-.01), Y(.81)); rf.closePath();
      soft(x, S, null, rf, '#B7862A', 'knit', [X(-.01), Y(.74), u(.95), u(.07)], { hair: false, hi: .05, lo: .3, rim: .35, cut: cut });
      x.strokeStyle = 'rgba(150,108,30,.95)'; x.lineWidth = 1.3; for (var fr = 0; fr < 34; fr++) { var frx = X(.005 + fr * .027); x.beginPath(); x.moveTo(frx, Y(.806)); x.lineTo(frx + rand(-1, 1), Y(.835)); x.stroke(); }
      return { mask: m, cut: cut, clean: [X(.08), Y(.36), u(.78), u(.28)], mitt: .14 };
    } },
    petbed: { hair: 'gold', density: 80, draw: function (x, W, H, S, ox, oy) {
      wood(x, W, H, '#CDB28E');
      var m = new Path2D(), u = function (v) { return v * S; }, cx = ox + u(.5), cy = oy + u(.52);
      var outer = new Path2D(); outer.ellipse(cx, cy, u(.45), u(.4), 0, 0, Math.PI * 2);
      part(x, S, m, outer, '#6F7F8C', 'fleece', { box: [cx - u(.45), cy - u(.4), u(.9), u(.8)], shadowA: .35 });
      x.save(); x.clip(outer); var rg = x.createRadialGradient(cx, cy, u(.25), cx, cy, u(.45)); rg.addColorStop(0, 'rgba(0,0,0,.25)'); rg.addColorStop(.35, 'rgba(255,255,255,.12)'); rg.addColorStop(1, 'rgba(0,0,0,.2)'); x.fillStyle = rg; x.fill(outer); x.restore();
      var inner = new Path2D(); inner.ellipse(cx, cy + u(.02), u(.3), u(.26), 0, 0, Math.PI * 2);
      part(x, S, m, inner, '#7E8E9A', 'fleece', { box: [cx - u(.3), cy - u(.24), u(.6), u(.52)], shadowA: .3, hi: .08 });
      return { mask: m, clean: [cx - u(.34), cy - u(.3), u(.68), u(.6)], mitt: .19 };
    } },
    rug: { hair: 'dark', density: 85, draw: function (x, W, H, S, ox, oy) {
      wood(x, W, H, '#C9AB84');
      var m = new Path2D(), u = function (v) { return v * S; };
      x.save(); x.translate(ox + u(.5), oy + u(.5)); x.rotate(-.1);
      var w = u(.7), h = u(.86);
      x.strokeStyle = '#E6DCCB'; x.lineWidth = Math.max(1, u(.005));
      for (var i = 0; i < 26; i++) { var fx = -w / 2 + (i + .5) * w / 26; x.beginPath(); x.moveTo(fx, -h / 2); x.lineTo(fx + rand(-2, 2), -h / 2 - u(.04)); x.moveTo(fx, h / 2); x.lineTo(fx + rand(-2, 2), h / 2 + u(.04)); x.stroke(); }
      var rp = RR(-w / 2, -h / 2, w, h, u(.01));
      part(x, S, null, rp, '#22344A', 'carpet', { box: [-w / 2, -h / 2, w, h], hair: false, side: false });
      var ip = RR(-w / 2 + u(.05), -h / 2 + u(.05), w - u(.1), h - u(.1), u(.005));
      part(x, S, null, ip, '#D9CCB6', 'carpet', { box: [-w / 2, -h / 2, w, h], shadow: false, side: false, lo: .12 });
      x.strokeStyle = 'rgba(34,52,74,.5)'; x.lineWidth = u(.008); x.strokeRect(-w / 2 + u(.09), -h / 2 + u(.09), w - u(.18), h - u(.18));
      x.restore();
      var mm = new Path2D(); var t = new DOMMatrix().translate(ox + u(.5), oy + u(.5)).rotate(-.1 * 180 / Math.PI); mm.addPath(RR(-w / 2, -h / 2, w, h, u(.01)), t); m.addPath(mm);
      return { mask: m, clean: [ox + u(.2), oy + u(.14), u(.6), u(.72)], mitt: .18 };
    } }
  };
  var HIT = document.createElement('canvas').getContext('2d');

  function Demo(el) {
    this.el = el;
    this.surface = SURFACES[el.dataset.surface] || SURFACES.sofa;
    this.scene = el.dataset.scene && SCENES[el.dataset.scene] ? SCENES[el.dataset.scene] : null;
    this.hairSet = HAIR[el.dataset.hair || (this.scene && this.scene.hair) || this.surface.hair] || HAIR.gold;
    this.mode = el.dataset.mode || 'auto';
    if (REDUCED && this.mode === 'auto') this.mode = 'split';
    this.canvas = document.createElement('canvas');
    this.canvas.setAttribute('aria-hidden', 'true');
    el.appendChild(this.canvas);
    this.ctx = this.canvas.getContext('2d');
    this.visible = false; this.running = false; this.t0 = 0;
    this.pointer = null; this.pressed = false;
    this.mitt = { x: 0, y: 0, r: 0, s: 1, lift: 1, flip: 0, alpha: 0 };
    this.collected = 0; this.total = 1; this.ready = false;
    var self = this;
    this.ro = new ResizeObserver(function () {
      if (!self.ready) return;
      var r = el.getBoundingClientRect();
      if (Math.round(r.width) === self.W && Math.round(r.height) === self.H) return;
      clearTimeout(self._rt); self._rt = setTimeout(function () { self.setup(); self.drawFrame(performance.now()); }, 150);
    });
    this.ro.observe(el);
    // Build lazily: only when the element is about to scroll into view.
    this.io = new IntersectionObserver(function (es) {
      self.visible = es[0].isIntersecting;
      if (!self.visible) return;
      if (!self.ready) {
        var go = function () { if (self.ready) return; self.setup(); self.ready = true; self.el.classList.add('is-ready'); self.start(); };
        if (self.el.hasAttribute('data-eager')) { go(); return; }
        var idle = function () { if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 600 }); else setTimeout(go, 60); };
        // Off-screen scenes wait for the page to finish loading so they never compete with first paint.
        if (document.readyState === 'complete') idle(); else window.addEventListener('load', function () { setTimeout(idle, 150); }, { once: true });
        return;
      }
      self.start();
    }, { rootMargin: '300px' });
    this.io.observe(el);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) self.start(); });
    if (this.mode === 'interactive') this.bindPointer();
  }

  Demo.prototype.setup = function () {
    var r = this.el.getBoundingClientRect();
    var W = Math.max(120, Math.round(r.width)), H = Math.max(120, Math.round(r.height));
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.W = W; this.H = H; this.dpr = dpr;
    this.canvas.width = W * dpr; this.canvas.height = H * dpr;
    this.canvas.style.width = W + 'px'; this.canvas.style.height = H + 'px';
    this.scale = clamp(Math.min(W, H) / 520, .62, 1.35) * (this.scene ? .78 : 1);
    this.buildSurface();
    this.mw = this.stage ? this.stage.S * this.stage.mitt : Math.min(W, H) * (this.mode === 'interactive' ? .26 : .3);
    this.mh = this.mw * 1.24;
    this.nap = mk(W * dpr, H * dpr); this.napCtx = this.nap.getContext('2d'); this.napCtx.scale(dpr, dpr);
    this.buildHair();
    if (this.mode !== 'dirty') { this.mesh = meshPattern(this.ctx); this.buildPad(); this.buildShadow(); }
    this.prev = null;
    if (this.mode === 'split') this.makeSplit();
    if (this.mode === 'interactive' && !this.pointer) { this.mitt.x = W / 2; this.mitt.y = H / 2; }
  };

  Demo.prototype.buildSurface = function () {
    var W = this.W, H = this.H, d = this.dpr;
    var c = mk(W * d, H * d), x = c.getContext('2d');
    x.scale(d, d);
    this.stage = null;
    if (this.scene) {
      var S = Math.min(W, H * .92), ox = (W - S) / 2, oy = (H - S) * .62;
      CUR_DPR = d;
      var info = this.scene.draw(x, W, H, S, ox, oy);
      this.stage = { S: S, mask: info.mask, cut: info.cut || null, clean: info.clean, mitt: info.mitt };
      this.surfaceCanvas = c; return;
    }
    x.fillStyle = x.createPattern(textureTile(this.surface.texture, this.surface.base), 'repeat');
    x.fillRect(0, 0, W, H);
    var g = x.createRadialGradient(W * .22, H * .12, 0, W * .22, H * .12, Math.max(W, H) * 1.05);
    g.addColorStop(0, 'rgba(255,248,232,.20)'); g.addColorStop(.55, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(8,16,26,.30)');
    x.fillStyle = g; x.fillRect(0, 0, W, H);
    this.surfaceCanvas = c;
  };

  Demo.prototype.drawStrand = function (x, px, py, len, ang, curve, col, lw) {
    var dx = Math.cos(ang) * len, dy = Math.sin(ang) * len;
    x.strokeStyle = col; x.lineWidth = lw;
    x.beginPath(); x.moveTo(px, py);
    x.quadraticCurveTo(px + dx / 2 - dy * curve, py + dy / 2 + dx * curve, px + dx, py + dy);
    x.stroke();
  };

  Demo.prototype.buildHair = function () {
    var W = this.W, H = this.H, d = this.dpr, s = this.scale;
    var c = this.hair && this.hair.width === W * d && this.hair.height === H * d ? this.hair : mk(W * d, H * d);
    var x = c.getContext('2d');
    x.setTransform(d, 0, 0, d, 0, 0); x.clearRect(0, 0, W, H); x.lineCap = 'round';
    var st = this.stage, area = st ? st.S * st.S : W * H;
    var R = st ? [(W - st.S) / 2, 0, st.S, H] : [0, 0, W, H];
    var n = Math.round(area / (st ? this.scene.density : this.surface.density));
    var cell = 24, gw = Math.ceil(W / cell), gh = Math.ceil(H / cell), grid = new Float32Array(gw * gh);
    var set = this.hairSet, buckets = {}, total = 0;
    // Strands are batched into one Path2D per colour/weight so the whole layer is ~20 draw calls.
    function bucket(col, wi) { var k = col + wi; return buckets[k] || (buckets[k] = { col: col, w: (1.05 + wi * .4) * s, p: new Path2D() }); }
    function strand(px, py, len, ang, curve, col, wi) {
      var dx = Math.cos(ang) * len, dy = Math.sin(ang) * len, p = bucket(col, wi).p;
      p.moveTo(px, py); p.quadraticCurveTo(px + dx / 2 - dy * curve, py + dy / 2 + dx * curve, px + dx, py + dy);
    }
    function log(px, py, k) { var gi = clamp((px / cell) | 0, 0, gw - 1) + clamp((py / cell) | 0, 0, gh - 1) * gw; grid[gi] += k; total += k; }
    function put(px, py, lenMul) {
      if (px < -10 || py < -10 || px > W + 10 || py > H + 10) return;
      if (st && (!HIT.isPointInPath(st.mask, px, py) || (st.cut && HIT.isPointInPath(st.cut, px, py)))) return;
      strand(px, py, rand(7, 21) * s * (lenMul || 1), rand(0, 6.283), rand(-.35, .35), pick(set), (Math.random() * 3) | 0);
      log(px, py, 1);
    }
    var i, k;
    for (i = 0; i < n; i++) put(R[0] + Math.random() * R[2], R[1] + Math.random() * R[3]);
    var clusters = 4 + ((Math.random() * 3) | 0);
    for (k = 0; k < clusters; k++) {
      var CB = st ? st.clean : [0, 0, W, H], cx = CB[0] + rand(.12, .88) * CB[2], cy = CB[1] + rand(.12, .88) * CB[3], spread = rand(.07, .14) * Math.min(CB[2], CB[3]);
      for (i = 0; i < n * (st ? .06 : .09); i++) put(cx + gauss() * spread, cy + gauss() * spread, 1.1);
    }
    for (k = 0; k < n / 60; k++) {
      var TB = st ? st.clean : [0, 0, W, H], tx = TB[0] + rand(.05, .95) * TB[2], ty = TB[1] + rand(.05, .95) * TB[3], ta = rand(0, 6.283), tc = pick(set);
      if (st && (!HIT.isPointInPath(st.mask, tx, ty) || (st.cut && HIT.isPointInPath(st.cut, tx, ty)))) continue;
      for (i = 0; i < 9; i++) strand(tx + gauss() * 2.5 * s, ty + gauss() * 2.5 * s, rand(12, 26) * s, ta + gauss() * .18, rand(-.2, .2), tc, 1);
      log(tx, ty, 9);
    }
    var keys = Object.keys(buckets), bk;
    x.save(); x.translate(.8 * s, 1 * s); x.globalAlpha = .2; x.strokeStyle = '#000';
    for (i = 0; i < keys.length; i++) { bk = buckets[keys[i]]; x.lineWidth = bk.w; x.stroke(bk.p); }
    x.restore();
    for (i = 0; i < keys.length; i++) { bk = buckets[keys[i]]; x.strokeStyle = bk.col; x.lineWidth = bk.w; x.globalAlpha = .92; x.stroke(bk.p); }
    x.globalAlpha = 1;
    this.hair = c; this.hairCtx = x;
    this.grid = grid; this.cell = cell; this.gw = gw; this.gh = gh;
    this.total = total; this.collected = 0; this.hairIn = 1;
    this.napCtx.clearRect(0, 0, W, H);
  };

  /* soft shadow sprite, blurred once instead of every frame */
  Demo.prototype.buildShadow = function () {
    var w = this.mw, h = this.mh, pad = 28, cw = w + pad * 2, ch = h + pad * 2, d = this.dpr;
    var c = mk(cw * d, ch * d), x = c.getContext('2d');
    x.scale(d, d); x.translate(cw / 2, ch / 2);
    x.filter = 'blur(12px)'; mittPath(x, w * .98, h * .98); x.fillStyle = 'rgba(5,12,20,.42)'; x.fill(); x.filter = 'none';
    c.cw = cw; c.ch = ch; this.shadow = c;
  };

  /* underside of the mitt with the gathered hair — the "result" reveal */
  Demo.prototype.buildPad = function () {
    var w = this.mw, h = this.mh, d = this.dpr, pad = 6;
    var c = mk((w + pad * 2) * d, (h + pad * 2) * d), x = c.getContext('2d');
    x.scale(d, d); x.translate(w / 2 + pad, h / 2 + pad);
    mittPath(x, w, h); x.fillStyle = '#16181B'; x.fill();
    x.save(); mittPath(x, w * .9, h * .92); x.clip();
    x.fillStyle = '#DADBD9'; x.fillRect(-w, -h, w * 2, h * 2);
    for (var i = 0; i < 400; i++) { x.fillStyle = Math.random() > .5 ? 'rgba(255,255,255,.5)' : 'rgba(0,0,0,.06)'; x.fillRect(rand(-w / 2, w / 2), rand(-h / 2, h / 2), 1.2, 1.2); }
    x.lineCap = 'round';
    var set = this.hairSet, paths = set.map(function () { return new Path2D(); });
    for (i = 0; i < 420; i++) {
      var t = rand(-.5, .5), band = gauss() * .09, ci = (Math.random() * set.length) | 0, pp = paths[ci];
      var px = t * w * .8 + band * w, py = -t * h * .55 + band * h * .6 + h * .05;
      var L = rand(8, 20) * this.scale, A = rand(-2.4, -1.9) + gauss() * .35, cu = rand(-.3, .3), dx = Math.cos(A) * L, dy = Math.sin(A) * L;
      pp.moveTo(px, py); pp.quadraticCurveTo(px + dx / 2 - dy * cu, py + dy / 2 + dx * cu, px + dx, py + dy);
    }
    x.lineWidth = this.scale; paths.forEach(function (pp, k) { x.strokeStyle = set[k]; x.stroke(pp); });
    x.restore();
    this.padCanvas = c; this.padPad = pad;
  };

  Demo.prototype.makeSplit = function () {
    // reduced-motion / static comparison: left half cleaned
    var x = this.hairCtx, W = this.W, H = this.H;
    x.save(); x.globalCompositeOperation = 'destination-out'; x.fillRect(0, 0, W * .5, H); x.restore();
    var n = this.napCtx; n.fillStyle = 'rgba(255,255,255,.05)'; n.fillRect(0, 0, W * .5, H);
    this.mitt.x = W * .5; this.mitt.y = H * .5; this.mitt.alpha = 1; this.mitt.lift = 0; this.mitt.r = -.08;
  };

  /* erase hair under the mitt footprint and log what was gathered */
  Demo.prototype.stamp = function (px, py, rot) {
    var w = this.mw * .92, h = this.mh * .92, x = this.hairCtx;
    x.save(); x.globalCompositeOperation = 'destination-out'; x.translate(px, py); x.rotate(rot);
    mittPath(x, w, h); x.fill(); x.restore();
    var n = this.napCtx; n.save(); n.translate(px, py); n.rotate(rot); mittPath(n, w * .96, h * .96);
    n.fillStyle = 'rgba(255,255,255,.0045)'; n.fill(); n.restore();
    var cell = this.cell, rr = w * .5, r2 = rr * rr, x0 = clamp(((px - rr) / cell) | 0, 0, this.gw - 1), x1 = clamp(((px + rr) / cell) | 0, 0, this.gw - 1), y0 = clamp(((py - rr) / cell) | 0, 0, this.gh - 1), y1 = clamp(((py + rr) / cell) | 0, 0, this.gh - 1);
    for (var gy = y0; gy <= y1; gy++) for (var gx = x0; gx <= x1; gx++) {
      var cx = (gx + .5) * cell - px, cy = (gy + .5) * cell - py;
      if (cx * cx + cy * cy < r2) { var i = gx + gy * this.gw; if (this.grid[i]) { this.collected += this.grid[i]; this.grid[i] = 0; } }
    }
  };

  Demo.prototype.sweepTo = function (px, py, rot) {
    if (this.prev) {
      var dx = px - this.prev.x, dy = py - this.prev.y, dist = Math.sqrt(dx * dx + dy * dy), steps = Math.ceil(dist / (this.mw * .12));
      for (var i = 1; i <= steps; i++) this.stamp(this.prev.x + dx * i / steps, this.prev.y + dy * i / steps, rot);
    } else this.stamp(px, py, rot);
    this.prev = { x: px, y: py };
  };

  /* ---------- Draw the mitt ---------- */
  Demo.prototype.drawMitt = function () {
    var m = this.mitt, x = this.ctx, w = this.mw, h = this.mh;
    if (m.alpha <= 0) return;
    var lift = m.lift, sc = 1 + lift * .1;
    x.save(); x.globalAlpha = m.alpha;
    // shadow
    var sh = this.shadow, ss = sc * (1 + lift * .12);
    x.save(); x.translate(m.x + 6 + lift * 22, m.y + 10 + lift * 30); x.rotate(m.r); x.globalAlpha = m.alpha * (1 - lift * .45);
    x.drawImage(sh, -sh.cw / 2 * ss, -sh.ch / 2 * ss, sh.cw * ss, sh.ch * ss); x.restore(); x.globalAlpha = m.alpha;
    x.translate(m.x, m.y); x.rotate(m.r);
    var fx = Math.cos(m.flip * Math.PI); // 1 → -1 : back → pad
    x.scale(sc * Math.abs(fx) + .0001, sc);
    if (fx < 0) {
      var p = this.padPad, pc = this.padCanvas;
      x.drawImage(pc, -w / 2 - p, -h / 2 - p, w + p * 2, h + p * 2);
    } else {
      this.fringe(x, w, h);
      mittPath(x, w, h); x.fillStyle = '#0E0F11'; x.fill();
      x.save(); mittPath(x, w * .93, h * .94); x.clip();
      x.fillStyle = this.mesh; x.fillRect(-w, -h, w * 2, h * 2);
      // yellow panel
      var yg = x.createLinearGradient(w * .18, 0, w * .5, 0); yg.addColorStop(0, '#E9B81A'); yg.addColorStop(.35, '#F7C928'); yg.addColorStop(1, '#FFD84F');
      x.fillStyle = yg; x.fillRect(w * .2, -h / 2 - 2, w * .32, h * .69);
      // centre seam
      x.fillStyle = 'rgba(0,0,0,.55)'; x.fillRect(-w * .012, -h / 2, w * .024, h * .69);
      // pocket band
      x.fillStyle = '#08090A'; x.fillRect(-w, h * .17, w * 2, h * .05);
      x.fillStyle = 'rgba(255,255,255,.08)'; x.fillRect(-w, h * .17, w * 2, 1);
      x.fillStyle = '#131517'; x.fillRect(-w, h * .22, w * 2, h);
      x.fillStyle = this.mesh; x.globalAlpha = m.alpha * .55; x.fillRect(-w, h * .22, w * 2, h); x.globalAlpha = m.alpha;
      // yellow pull tab
      x.fillStyle = '#F7C928'; x.beginPath(); if (x.roundRect) x.roundRect(-w * .03, h * .05, w * .06, h * .13, w * .02); else x.rect(-w * .03, h * .05, w * .06, h * .13); x.fill();
      // soft top-left light
      var lg = x.createLinearGradient(-w / 2, -h / 2, w / 2, h / 2); lg.addColorStop(0, 'rgba(255,255,255,.14)'); lg.addColorStop(.5, 'rgba(255,255,255,0)'); lg.addColorStop(1, 'rgba(0,0,0,.25)');
      x.fillStyle = lg; x.fillRect(-w, -h, w * 2, h * 2);
      x.restore();
      // piping
      mittPath(x, w, h); x.lineWidth = w * .035; x.strokeStyle = '#08090A'; x.stroke();
      mittPath(x, w * .985, h * .985); x.lineWidth = 1; x.strokeStyle = 'rgba(255,255,255,.14)'; x.stroke();
    }
    x.restore();
  };

  /* hair caught on the pad edge grows as the mitt gathers more */
  Demo.prototype.fringe = function (x, w, h) {
    var amt = clamp(this.collected / this.total, 0, 1);
    if (amt < .02) return;
    if (!this.fringeSeeds) { this.fringeSeeds = []; for (var i = 0; i < 90; i++) this.fringeSeeds.push({ a: rand(0, 6.283), l: rand(.5, 1.2), c: pick(this.hairSet), k: Math.random() }); }
    x.save(); x.lineCap = 'round';
    for (var j = 0; j < this.fringeSeeds.length; j++) {
      var f = this.fringeSeeds[j]; if (f.k > amt) continue;
      var ex = Math.cos(f.a) * w * .5, ey = Math.sin(f.a) * h * .5;
      x.strokeStyle = f.c; x.lineWidth = this.scale; x.globalAlpha = .9;
      x.beginPath(); x.moveTo(ex * .92, ey * .92); x.lineTo(ex * (1 + .09 * f.l), ey * (1 + .07 * f.l)); x.stroke();
    }
    x.restore();
  };

  /* ---------- Timeline (auto mode) ---------- */
  Demo.prototype.route = function () {
    var W = this.W, H = this.H, mx = this.mw * .42, my = this.mh * .42, bx = 0, by = 0;
    if (this.stage) { var cb = this.stage.clean; bx = cb[0]; by = cb[1]; W = cb[2]; H = cb[3]; mx = this.mw * .3; my = this.mh * .3; }
    var rows = Math.max(3, Math.ceil((H - my * 2) / (this.mh * .72)) + 1), pts = [], i;
    for (i = 0; i < rows; i++) {
      var y = lerp(my, H - my, i / (rows - 1)) + rand(-6, 6);
      var a = i % 2 === 0 ? mx : W - mx, b = i % 2 === 0 ? W - mx : mx;
      if (i === 0) pts.push([a, y]);
      pts.push([b, y + rand(-10, 10)]);
      if (i < rows - 1) pts.push([b + (i % 2 ? 14 : -14), lerp(my, H - my, (i + 1) / (rows - 1))]);
    }
    return pts.map(function (p) { return [p[0] + bx, p[1] + by]; });
  };

  Demo.prototype.drawFrame = function (now) {
    var x = this.ctx, W = this.W, H = this.H, d = this.dpr;
    x.setTransform(d, 0, 0, d, 0, 0);
    x.clearRect(0, 0, W, H);
    x.drawImage(this.surfaceCanvas, 0, 0, W, H);
    x.drawImage(this.nap, 0, 0, W, H);
    x.globalAlpha = this.hairIn; x.drawImage(this.hair, 0, 0, W, H); x.globalAlpha = 1;
    if (this.mode !== 'dirty') this.drawMitt();
  };

  Demo.prototype.tickAuto = function (now) {
    if (!this.plan) {
      var pts = this.route(), segs = [], t = 700, i;
      var enterFrom = [this.W + this.mw, this.H * .15];
      segs.push({ type: 'enter', a: enterFrom, b: pts[0], t0: t, dur: 800 }); t += 800;
      for (i = 1; i < pts.length; i++) {
        var dx = pts[i][0] - pts[i - 1][0], dy = pts[i][1] - pts[i - 1][1], dist = Math.sqrt(dx * dx + dy * dy);
        var dur = clamp(dist / (this.W * .8) * 1000, 320, 1100);
        segs.push({ type: 'sweep', a: pts[i - 1], b: pts[i], t0: t, dur: dur }); t += dur;
      }
      segs.push({ type: 'lift', a: pts[pts.length - 1], b: [this.W / 2, this.H / 2], t0: t, dur: 800 }); t += 800;
      segs.push({ type: 'flip', t0: t, dur: 650 }); t += 650;
      segs.push({ type: 'hold', t0: t, dur: 1500 }); t += 1500;
      segs.push({ type: 'exit', a: [this.W / 2, this.H / 2], b: [-this.mw * 1.4, this.H * .35], t0: t, dur: 700 }); t += 700;
      segs.push({ type: 'regrow', t0: t, dur: 700 }); t += 700;
      this.plan = { segs: segs, total: t }; this.t0 = now; this.prev = null;
      this.mitt.flip = 0; this.mitt.alpha = 0;
    }
    var el = now - this.t0, m = this.mitt, s, k;
    for (var i = 0; i < this.plan.segs.length; i++) {
      s = this.plan.segs[i]; if (el < s.t0 || el > s.t0 + s.dur) continue;
      k = (el - s.t0) / s.dur;
      if (s.type === 'enter') { var e = easeOut(k); m.x = lerp(s.a[0], s.b[0], e); m.y = lerp(s.a[1], s.b[1], e); m.lift = 1 - e; m.alpha = 1; m.r = lerp(.35, -.06, e); }
      else if (s.type === 'sweep') { var e2 = ease(k); m.x = lerp(s.a[0], s.b[0], e2); m.y = lerp(s.a[1], s.b[1], e2); m.lift = 0; var dir = s.b[0] - s.a[0]; m.r = lerp(m.r, clamp(dir / this.W, -1, 1) * .14 - .04, .12); this.sweepTo(m.x, m.y, m.r); }
      else if (s.type === 'lift') { var e3 = ease(k); m.x = lerp(s.a[0], s.b[0], e3); m.y = lerp(s.a[1], s.b[1], e3); m.lift = easeOut(k); m.r = lerp(m.r, 0, .1); this.prev = null; }
      else if (s.type === 'flip') { m.flip = ease(k); }
      else if (s.type === 'hold') { m.flip = 1; }
      else if (s.type === 'exit') { var e4 = ease(k); m.x = lerp(s.a[0], s.b[0], e4); m.y = lerp(s.a[1], s.b[1], e4); m.alpha = 1 - k; m.r = lerp(0, -.3, e4); }
      else if (s.type === 'regrow') { if (!this._regrown) { this.buildHair(); this.fringeSeeds = null; this._regrown = true; } this.hairIn = easeOut(k); m.alpha = 0; }
    }
    if (el > this.plan.total) { this.plan = null; this._regrown = false; this.hairIn = 1; }
  };

  Demo.prototype.tickInteractive = function () {
    var m = this.mitt;
    if (!this.pointer) { m.alpha = lerp(m.alpha, this.hinting ? 1 : 0, .1); if (this.hinting) this.hint(); }
    else {
      m.alpha = lerp(m.alpha, 1, .2);
      var tx = this.pointer.x, ty = this.pointer.y, vx = tx - m.x;
      m.x = lerp(m.x, tx, .38); m.y = lerp(m.y, ty, .38);
      m.r = lerp(m.r, clamp(vx / 60, -1, 1) * .18, .15);
      m.lift = lerp(m.lift, this.pressed ? 0 : .7, .25);
      if (this.pressed) this.sweepTo(m.x, m.y, m.r); else this.prev = null;
      var pct = this.collected / this.total;
      if (Math.abs(pct - (this._lastPct || 0)) > .004) { this._lastPct = pct; this.el.dispatchEvent(new CustomEvent('nit:progress', { detail: pct })); }
    }
    if (this.flipping) { m.flip = lerp(m.flip, 1, .12); m.lift = lerp(m.lift, 1, .1); }
  };

  Demo.prototype.hint = function () {
    var t = (performance.now() % 3000) / 3000, m = this.mitt;
    m.x = this.W * (.3 + .4 * Math.sin(t * Math.PI * 2) * .5 + .2); m.y = this.H * .55; m.lift = .6; m.r = Math.sin(t * 6.283) * .08;
  };

  Demo.prototype.bindPointer = function () {
    var self = this, c = this.canvas;
    this.hinting = true;
    function pos(e) { var r = c.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    c.addEventListener('pointerdown', function (e) { if (self.flipping) return; self.hinting = false; self.pressed = true; self.pointer = pos(e); self.mitt.x = self.pointer.x; self.mitt.y = self.pointer.y; try { c.setPointerCapture(e.pointerId); } catch (_) {} self.start(); e.preventDefault(); });
    c.addEventListener('pointermove', function (e) { if (self.flipping) return; if (e.pointerType === 'mouse' || self.pressed) { self.hinting = false; self.pointer = pos(e); self.start(); } });
    c.addEventListener('pointerup', function () { if (self.flipping) return; self.pressed = false; self.prev = null; if (self.el.dataset.touch === '1') self.pointer = null; });
    c.addEventListener('pointercancel', function () { self.pressed = false; self.prev = null; });
    c.addEventListener('pointerleave', function (e) { if (self.flipping) return; if (e.pointerType === 'mouse') { self.pointer = null; self.pressed = false; self.prev = null; } });
    c.addEventListener('touchstart', function () { self.el.dataset.touch = '1'; }, { passive: true });
  };

  Demo.prototype.finish = function () { this.flipping = true; this.pressed = false; this.prev = null; this.pointer = { x: this.W / 2, y: this.H * .38 }; this.start(); };
  Demo.prototype.reset = function () { this.flipping = false; this.mitt.flip = 0; this.fringeSeeds = null; this.buildHair(); this.pointer = null; this.hinting = true; this._lastPct = 0; this.el.dispatchEvent(new CustomEvent('nit:progress', { detail: 0 })); this.start(); };

  Demo.prototype.start = function () {
    if (this.running || !this.ready) return;
    if (this.mode === 'dirty' || this.mode === 'split') { this.drawFrame(performance.now()); return; }
    this.running = true;
    var self = this;
    (function loop(now) {
      if (!self.visible || document.hidden) { self.running = false; if (self.plan) self.pausedAt = now - self.t0; return; }
      if (self.pausedAt != null) { self.t0 = now - self.pausedAt; self.pausedAt = null; }
      if (self.mode === 'auto') self.tickAuto(now); else self.tickInteractive(now);
      self.drawFrame(now);
      requestAnimationFrame(loop);
    })(performance.now());
  };

  customElements.define('nit-demo', class extends HTMLElement {
    connectedCallback() { if (!this.demo) this.demo = new Demo(this); }
  });
})();
